module.exports = __webpack_public_path__ + "static/media/view3.7269cbf3.jpg";